import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray, AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';
import { GenericResponse, LeadResponse, DecisionTypes, UpdateDecisionTimes, DecisionParameters, DecisionRules } from 'src/app/interfaces/apiresponses';
import { RestService } from 'src/app/services/rest/rest.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
  providers: [DatePipe]
})
export class OnboardingComponent {
  autoOnboardingTime:any;
  invitationValidity:any;
  tat:any;
  autoOnboardingStrategy:any;
  showtime:boolean=false;
  onBoardingForm!: FormGroup
  selectedItem: any
  decisionSaveModel: boolean = false
  bView: boolean = false
  columns = [
    // {
    //   key: 'id',
    //   label: 'ID',
    //   _cellProps: { align: 'middle' },
    //   filter: true
    // },
    {
      key: 'name',
      label: 'Decision Name',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'decisionType',
      label: 'Decision type',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'decisionRule',
      label: 'Decision rule',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'sourceType',
      label: 'Source type',
      _cellProps: { align: 'middle' },
      filter: true
    },
    {
      key: 'sources',
      label: 'Sources Value',
      _cellProps: { align: 'middle' },
      filter: true
    }
  ];
  gaugeTitleForm!: FormGroup;
  gaugeTitles!: FormArray;
  decisionTable: any = []
  selectedItems = [2, 3];
  DecisionParameters: any = []
  DecisionRules: any = []
  DecisionTypes: any = []
  getRowValueData: any; 
  constructor(private restApi: RestService, private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private changeDetector: ChangeDetectorRef) {
    this.getDecisionDataTypes()
    

  }
  myForm = this.formBuilder.group({
    name: [{ value: '', disabled: true }],
    decisionType: [{ value: '', disabled: true }],
    decisionRule: [{ value: '', disabled: true }],
    sourceType: [{ value: '', disabled: true }],
    documents: this.formBuilder.array([])
  });
 
  submitForm() { console.log(this.myForm, this.documentsControl) }
  get documentsControl(): FormArray {
    return this.myForm.get("documents") as FormArray;
  }

  ngOnInit() {
  

  }
  v1:any
  add() {
    console.log(this.documentsControl.value)
    const v1= this.myForm.value.documents;
   const lastId2 = this.documentsControl.value[this.documentsControl.value.length - 1].key;
   console.log(lastId2 )
   // let indexValue = this.documentsControl.value.map(itme)=>;
     let indexValue = this.getRowValueData?.sourceComplete.map((item:any)=>{ return item?.key.toString()})   
     console.log(indexValue)
    const lastId = this.getRowValueData?.sourceComplete[this.getRowValueData?.sourceComplete.length - 1].key;
    const lastValue = this.getRowValueData?.sourceComplete[this.getRowValueData?.sourceComplete.length - 1].value;
    
    console.log( lastId, lastValue)
    let updateId = Number(lastId) + 1;
    console.log( updateId)
    this.documentsControl.push(
      this.formBuilder.group({
        key: [(Number(lastId2)+ 1).toString(), Validators.required],
        value: [null, Validators.required]
      })
    );
  }
  removerow(index: any) {
    console.log(index, this.documentsControl.value.length)
    this.documentsControl.removeAt(index);
  }
  remove() {
    this.myForm = this.formBuilder.group({
      name: [{ value: '', disabled: true }],
      decisionType: [{ value: '', disabled: true }],
      decisionRule: [{ value: '', disabled: true }],
      sourceType: [{ value: '', disabled: true }],
      documents: this.formBuilder.array([])
    });
  }
  // insert(index: any) {

  //   this.documentsControl.insert(
  //     index + 1,
  //     this.formBuilder.group({
  //       key: [index],
  //       value: [null, Validators.required],

  //     })
  //   );
  // }
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  // Search Form
  searchCompanyName: string = ''
  searchTrandeLicense: string = ''
  rowSelected(event: any) {
    if (event?.item?.sourceType == "JSON") {
      this.myForm.controls.documents.reset()
      this.getRowValueData = event.item
      this.decisionSaveModel = true;
      console.log(this.getRowValueData.sourceComplete)
      if (this.getRowValueData.sourceComplete?.length) {
        this.getRowValueData?.sourceComplete.forEach((document: any) =>
          this.documentsControl.push(
            this.formBuilder.group({
              key: [document.key.toString(), Validators.required],
              value: [document.value],
            })
          )
        );
      }
    } else {
      this.decisionSaveModel = false;
      event.stopPropagation()
      event.preventDefault()
      return
    }
  }
  getDecisionDataTypes() {
    this.restApi.getDecisionDataTypes().subscribe({
      next: (v: DecisionTypes) => {
        if (v.success) {
          //this.DecisionTypes = v.decisionTypes
          this.DecisionTypes = v.decisionTypes.map((item, UserId) => {
            const _selected = this.selectedItems.includes(UserId);
            return {
              ...item,
              _selected
            };
          })

          this.getDecisionRules()

        }
      },
      error: (e) => {

      }
    })
  }
  getDecisionRules() {
    this.restApi.getDecisionRules().subscribe({
      next: (v: DecisionRules) => {
        if (v.success) {
          this.DecisionRules = v.rules
          this.DecisionRules = v.rules.map((item, UserId) => {
            const _selected = this.selectedItems.includes(UserId);
            return {
              ...item,
              _selected
            };
          })
          this.getDecisionParameters()
        }
      },
      error: (e) => {

      }
    })
  }
  autoInitialValue:any;
  decisionValue: any = []
  rowValues: any = []
  getDecisionParameters() {
    this.restApi.getDecisionParameters().subscribe({
      next: (v: DecisionParameters) => {
        if (v.success) {
          this.autoInitialValue = v
          this.DecisionParameters = v.parameters.map((item, id) => {
            let finalarray = item.sources.map((itemSource) => {
              return itemSource?.value
            }).join(',')

            const decisionRule = this.DecisionRules.find((tempObject: any) => tempObject.id === item.decisionRule);
            const decisionType = this.DecisionTypes.find((tempObject: any) => tempObject.id === item.decisionType);
            let sources = finalarray.substring(0, 20) + "..."
            const _selected = this.selectedItems.includes(id);
            return {
              ...item,
              _selected,
              sources,
              sourceComplete: item.sources,
              decisionRule: decisionRule?.description,
              decisionType: decisionType?.dataType,
              completeSourceItem: this.DecisionRules,
              type:item.decisionType,
              rule: item.decisionRule
            };
          })
        }
        //console.log(this.autoInitialValue)
      },
      error: (e) => {

      }
    })
  }

  submit() {
    if (this.myForm.status == "INVALID") {
      this.showAlertBox('Sorry!', 'Source Value should not be Blank!');
      return;
    } 
    if(this.myForm.value.documents?.length === 0){
      this.showAlertBox('Sorry!', 'Source Value should not be Blank!');
      return;
    }
    else {    

      let payload = {

        "parameterData": {
        "id": this.getRowValueData.id,
        "name": this.getRowValueData.name,
        "decisionType": this.getRowValueData.type,
        "decisionRule": this.getRowValueData.rule,
        "sourceType": this.getRowValueData.sourceType,
        "modelName": this.getRowValueData.modelName,
        "sources": this.myForm.value.documents
        }
    
      }

      console.log(payload)
      this.restApi.updateDecisionParameter(payload).subscribe({
        next: (v: GenericResponse) => {
          if (v.success) {
            console.log(v.success)
            this.decisionSaveModel = false;
            this.goBackToSearchScreen()
          }
        },
        error: (e) => {
  
        }
      })
    }


  }
  myForm2 = this.formBuilder.group({
    autoOnboardingTime: [null,[Validators.required]],
    invitationValidity: [null, [Validators.required]],
    tat: [null, [Validators.required]],
    autoOnboardingStrategy: [null, [Validators.required]],
  });

  timeVal(val1:any, val2:any,val3:any,val4:any){
    this.showtime = true
    console.log(val1,val2)
    this.myForm2 = this.formBuilder.group({
      autoOnboardingTime: [val1],
      invitationValidity: [val2],
      tat: [val3],
      autoOnboardingStrategy: [val4],
    });
  }
  goBackTomainScreen(){
    this.getDecisionParameters()
    this.showtime = false
    
  }
  timeValueUpdate(){
    console.log(this.myForm2)
    // if (this.myForm2.value?.autoOnboardingTime === null  ) {
    //   this.showAlertBox('Sorry!', 'Onboarding Time should not be Blank!');
    //   return;
    // }
    // else if(Number(this.myForm2.value?.autoOnboardingTime) < 0){
    //   this.showAlertBox('Sorry!', 'Onboarding Time should not be Negative value');
    //   return;
    // }
    // else if(Number(this.myForm2.value?.autoOnboardingTime) > 1000){
    //   this.showAlertBox('Sorry!', 'Onboarding Time should not be greater than 1000');
    //   return;
    // }    
    if (this.myForm2.value?.invitationValidity === null  ) {
      this.showAlertBox('Sorry!', 'Validity should not be Blank!');
      return;
    }
    else if(Number(this.myForm2.value?.invitationValidity) < 0){
      this.showAlertBox('Sorry!', 'Validity should not be Negative value');
      return;
    }
    else if(Number(this.myForm2.value?.invitationValidity) > 1000){
      this.showAlertBox('Sorry!', 'Validity should not be greater than 1000');
      return;
    }    
    if (this.myForm2.value?.tat === null  ) {
      this.showAlertBox('Sorry!', 'Onboarding Time should not be Blank!');
      return;
    }
    else if(Number(this.myForm2.value?.tat) < 0){
      this.showAlertBox('Sorry!', 'Onboarding Time should not be Negative value');
      return;
    }
    else if(Number(this.myForm2.value?.tat) > 1000){
      this.showAlertBox('Sorry!', 'Onboarding Time should not be greater than 1000');
      return;
    }
    let payload = {
      "autoOnboardingTime": this.myForm2.value?.autoOnboardingTime,
      "invitationValidity": this.myForm2.value?.invitationValidity,
      "tat": this.myForm2.value?.tat,
      "autoOnboardingStrategy": this.myForm2.value?.autoOnboardingStrategy,
    }
    this.restApi.updateDecisionTimes(payload).subscribe({
      next: (v: UpdateDecisionTimes) => {
        if (v.success) {
          console.log(v.success)
          this.goBackTomainScreen()
        }
      },
      error: (e) => {

      }
    })
  }
  goBackToSearchScreen() {
    this.decisionSaveModel = false;
    this.remove()
    this.getDecisionParameters()

  }

  // Alert buttons
  bAlert = false
  alertHeaderText = ""
  alertBodyText = ""
  bShowSecondAlertButton = false
  alertSecondButtonText = ""
  alertCloseButtonText = "Close"
  alertBoxData: any
  showAlertBox(heading: string, body: string, closeButtonText: string = "Close", showSecondButton: boolean = false, secondButtonText: string = "Understood", data: any = {}) {
    this.alertHeaderText = heading
    this.alertBodyText = body
    this.bShowSecondAlertButton = showSecondButton
    this.alertSecondButtonText = secondButtonText
    this.alertCloseButtonText = closeButtonText
    this.alertBoxData = data
    this.bAlert = true
  }

  onAlertButtonClick(event: any) {

  }

  closeAlert(event: any) {
    this.bAlert = event.state
  }

  alertVisibility(event: any) {
    this.bAlert = event.state
  }


}
